import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReceiptLongOutlined } from '@mui/icons-material';
import { RoutePaths } from '../../routes/AppRoutes';
import CompanyInfoSection from '../CompanyInfoSection';
import TopAppBar from '../../common/components/TopAppBar';
import InvoicingAddressInfo from './address/InvoicingAddressInfo';
import ContactsInfo from './contacts/ContactsInfo';

export default function BuyerBillingInfoPage(): React.JSX.Element {
  const { t } = useTranslation(['common']);

  return (
    <>
      <TopAppBar
        configuration="small"
        backTo={RoutePaths.NAVIGATION_MAIN}
        shouldCheckHistory={false}
        title={t('common:billing')}
        sx={{
          position: 'fixed',
        }}
      />
      <Box
        sx={{
          height: {
            lg: 'calc(100% - 48px)',
          },
          mt: {
            xs: 6.5,
            lg: 0,
          },
          p: {
            xs: 1,
            lg: 3,
          },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'start',
          gap: 3,
          overflow: 'auto',
        }}
      >
        <Box
          sx={{
            display: {
              xs: 'none',
              lg: 'flex',
            },
            alignItems: 'center',
            gap: 1,
          }}
        >
          <ReceiptLongOutlined height={32} width={32} />
          <Typography variant="titleLarge">
            {t('common:billing')}
          </Typography>
        </Box>
        <CompanyInfoSection icon="📍" title={t('common:address')}>
          <InvoicingAddressInfo />
        </CompanyInfoSection>
        <CompanyInfoSection icon="👤" title={t('common:contacts')}>
          <ContactsInfo type="INVOICING" />
        </CompanyInfoSection>
      </Box>
    </>
  );
}
